export enum ApiErrorCode {
  SubscriptionLimitExceeded = 'SUBSCRIPTION LIMIT EXCEEDED',
  InvalidFile = 'INVALID FILE',
  EmptyUserList = 'EMPTY USER LIST',
  AllUsersExist = 'ALL USERS ALREADY EXIST',
  Unknown = 'UNKNOWN_ERROR',
}
